// Keep missing values last in either direction and preserve original order for ties.
export function sortNumericRows(rows, getValue, direction) {
  const value = (row) => {
    const v = getValue(row);
    return v === null || v === undefined || v === '' || !Number.isFinite(Number(v)) ? null : Number(v);
  };
  return rows.map((row, index) => ({ row, index, value: value(row) })).sort((a, b) => {
    if (a.value === null || b.value === null) return a.value === b.value ? a.index - b.index : a.value === null ? 1 : -1;
    return (direction === 'asc' ? a.value - b.value : b.value - a.value) || a.index - b.index;
  }).map(({ row }) => row);
}
